var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from 'react';
import { Loader } from '../../../components/Loader/Loader';
import { LoaderType } from '../../../components/Loader/LoaderType.enum';
import { tvAuthService } from '../../../services/TvAuthService';
import { withTranslation } from 'react-i18next';
import { setInitialPasswordButtonLinkConstants } from '../../SetInitialPassword/Set-initial-password-constants';
var SetPassword = (function (_super) {
    __extends(SetPassword, _super);
    function SetPassword(props) {
        var _this = _super.call(this, props) || this;
        _this.handleChange = function (name, value) {
            if (name === 'password') {
                _this.setState({ password: value, isValidPassword: '', confirmPassword: '', passwordMismatch: '' });
            }
            else if (name === 'confirmPassword') {
                _this.setState({ confirmPassword: value, passwordMismatch: '', isError: false });
            }
            else {
                _this.setState({ smsCode: value, isError: false });
            }
        };
        _this.callIfEnter = function (event, callback, value, name) {
            var _a = _this.state, password = _a.password, passwordMismatch = _a.passwordMismatch;
            if (event && event.key === 'Enter' && callback && callback instanceof Function) {
                if (name === 'confirmPassword' && value) {
                    {
                        password === value ? _this.setState({ passwordMismatch: false }) : _this.setState({ passwordMismatch: true });
                    }
                    if (!passwordMismatch && passwordMismatch !== '')
                        callback();
                }
            }
        };
        _this.handleSave = function () {
            var _a = _this.state, password = _a.password, isValidPassword = _a.isValidPassword, passwordMismatch = _a.passwordMismatch, isError = _a.isError, smsCode = _a.smsCode;
            var loginId = _this.props.loginId;
            var cleanMsisdn = tvAuthService.removeSpaces(loginId);
            if (isValidPassword && !passwordMismatch && smsCode && !isError) {
                _this.setState({ isLoading: true });
                tvAuthService.setPassword(cleanMsisdn, password, smsCode, _this.updateSuccess, _this.updateError, 'TV_OTP');
            }
            else if (!passwordMismatch) {
                _this.setState({ isError: true, isLoading: false });
            }
        };
        _this.updateSuccess = function () {
            _this.setState({ isSuccess: true, isLoading: false });
            if (typeof _this.props.isPasswordSet === 'function') {
                _this.props.isPasswordSet(true);
            }
        };
        _this.updateError = function (response) {
            _this.setState({ isError: true, errorCode: response.errorCode, isLoading: false });
        };
        _this.getUrlParams = function (params) {
            var urlParams = new URLSearchParams(location.search.replace('#/', ''));
            return urlParams && urlParams.get(params) || '';
        };
        _this.handleSuccess = function () {
            var t = _this.props.t;
            return (React.createElement("div", { className: "s20-alert-teaser__container" },
                React.createElement("div", { className: "s20-alert-teaser__icon s20-alert-teaser__icon--success-v2" }),
                React.createElement("div", { className: "s20-alert-teaser__title" },
                    React.createElement("h3", { className: "s20-teaser-title s20-teaser-title--regular s20-teaser-title--small" }, t("SetPassword.Registered.Success"))),
                React.createElement("div", { className: "s20-alert-teaser__text" }, t("SetPassword.Login.Success.Info")),
                React.createElement("div", { className: "s20-spacer s20-spacer--x12" }),
                React.createElement("div", { className: "s20-alert-teaser__text" }, t("SetPassword.Logout.Text"))));
        };
        _this.handleBlur = function (value, name) {
            var password = _this.state.password;
            var regExp = /^(?=.*[a-zA-Z])(?=.*[0-9])(?=.{8,20}$)/;
            if (name === 'password' && value) {
                {
                    regExp.test(value) ? _this.setState({ isValidPassword: true }) : _this.setState({ isValidPassword: false });
                }
            }
            if (name === 'confirmPassword' && value) {
                {
                    password === value ? _this.setState({ passwordMismatch: false }) : _this.setState({ passwordMismatch: true });
                }
            }
            if (name === 'smsCode' && value) {
                {
                    _this.setState({ isValidCode: true });
                }
            }
        };
        _this.onClick = function () {
            if (typeof _this.props.updateStep === 'function') {
                _this.props.updateStep("1");
            }
        };
        _this.callIfKeyPressed = function (event) {
            var element = document.getElementById('confirmPassword');
            var removeClass = element && element.closest('.s20-form-input--md');
            if (event && (event.key === 'Backspace' || event.key === 'Delete')) {
                if (element) {
                    element.setAttribute('value', '');
                    removeClass && removeClass.classList.remove('s20-form-input--md-active');
                }
            }
        };
        _this.state = {
            isLoading: false,
            password: '',
            confirmPassword: '',
            passwordMismatch: '',
            isValidPassword: '',
            isSuccess: false,
            isError: false,
            errorCode: '',
            smsCode: '',
            isValidCode: ''
        };
        return _this;
    }
    SetPassword.prototype.renderTitle = function () {
        var t = this.props.t;
        return (React.createElement("h3", { className: "s20-teaser-title s20-teaser-title--regular" }, t("SetPassword.Otp.Info")));
    };
    SetPassword.prototype.renderSaveButton = function () {
        var _a = this.state, password = _a.password, confirmPassword = _a.confirmPassword, smsCode = _a.smsCode;
        var t = this.props.t;
        return (React.createElement("div", { className: 's20-form-buttons__item' },
            React.createElement("button", { onClick: this.handleSave, className: 's20-button', disabled: !(password && confirmPassword && smsCode) }, t && t("SetPassword.Button.Save"))));
    };
    SetPassword.prototype.renderFormButtons = function () {
        return (React.createElement("div", { className: 's20-form-buttons s20-form-buttons--right' }, this.renderSaveButton()));
    };
    SetPassword.prototype.fetchURL = function () {
        switch (this.getUrlParams('lang')) {
            case setInitialPasswordButtonLinkConstants.EN: return setInitialPasswordButtonLinkConstants.EN_SUPPORT_LINK;
            case setInitialPasswordButtonLinkConstants.FR: return setInitialPasswordButtonLinkConstants.FR_SUPPORT_LINK;
            case setInitialPasswordButtonLinkConstants.IT: return setInitialPasswordButtonLinkConstants.IT_SUPPORT_LINK;
            default: return setInitialPasswordButtonLinkConstants.DE_SUPPORT_LINK;
        }
    };
    SetPassword.prototype.renderPasswordField = function () {
        var _this = this;
        var _a = this.state, password = _a.password, isValidPassword = _a.isValidPassword;
        var t = this.props.t;
        var addClass = '';
        if (password && isValidPassword !== '') {
            (!isValidPassword ? addClass = 'is-error' : addClass = 'is-success');
        }
        return (React.createElement("div", { className: "s20-form-item has-no-bottom-margin " + addClass },
            React.createElement("div", { className: 's20-form-input s20-form-input--text s20-form-input--md' },
                React.createElement("label", { className: 's20-form-label', htmlFor: 'password' }, t && t("SetAppPassword.Password.Label")),
                React.createElement("input", { id: 'password', name: 'password', type: 'password', value: password, className: 's20-form-input__field js-check-field', onChange: function (e) { return _this.handleChange(e.target.name, e.target.value); }, onBlur: function (e) { return _this.handleBlur(e.target.value, e.target.name); }, onKeyDown: function (event) { return _this.callIfKeyPressed(event); }, autoComplete: 'new-password' })),
            addClass === 'is-error' ? React.createElement("div", { className: 's20-form-note' }, t && t("SetPassword.Password.NotStrong.Error")) : null));
    };
    SetPassword.prototype.renderConfirmPasswordField = function () {
        var _this = this;
        var _a = this.state, confirmPassword = _a.confirmPassword, passwordMismatch = _a.passwordMismatch, password = _a.password;
        var t = this.props.t;
        var addClass = '';
        if (confirmPassword && passwordMismatch !== '') {
            (passwordMismatch ? addClass = 'is-error' : addClass = 'is-success');
        }
        return (React.createElement("div", { className: "s20-form-item has-no-bottom-margin " + addClass },
            React.createElement("div", { className: 's20-form-input s20-form-input--text s20-form-input--md' },
                React.createElement("label", { className: 's20-form-label', htmlFor: 'confirmPassword' }, t && t("SetPassword.ConfirmPassword.Label")),
                React.createElement("input", { name: 'confirmPassword', id: 'confirmPassword', type: 'password', value: confirmPassword, className: 's20-form-input__field js-check-field', onKeyDown: function (event) { return _this.callIfEnter(event, _this.handleSave, confirmPassword, 'confirmPassword'); }, disabled: !password, onChange: function (e) { return _this.handleChange(e.target.name, e.target.value); }, onBlur: function (e) { return _this.handleBlur(e.target.value, e.target.name); } })),
            passwordMismatch ? React.createElement("div", { className: 's20-form-note' }, t && t("SetPassword.Password.Mismatch.Error")) : null));
    };
    SetPassword.prototype.handleError = function () {
        var t = this.props.t;
        var errorCode = this.state.errorCode;
        if (errorCode === 'INVALID_OTP') {
            return null;
        }
        return (React.createElement("div", { className: 'form_alert form_alert-error', role: 'alert' },
            React.createElement("h2", { className: 'form_alert--heading' }, t("SetPassword.Error.Title")),
            React.createElement("div", { className: 'form_alert__flex_container' },
                React.createElement("div", null,
                    React.createElement("i", { className: 'form_alert--icon icon' })),
                React.createElement("div", { className: 'form_alert--list--content' },
                    React.createElement("ul", { className: 'form_alert--list' },
                        React.createElement("li", null,
                            React.createElement("a", null, errorCode ? t("SetPassword.Error." + errorCode) : t("SetPassword.Error.Label"))))))));
    };
    SetPassword.prototype.enterOtp = function () {
        var _this = this;
        var _a = this.props, loginId = _a.loginId, t = _a.t;
        var _b = this.state, smsCode = _b.smsCode, isValidCode = _b.isValidCode, errorCode = _b.errorCode;
        var addClass = '';
        if (smsCode && isValidCode !== '') {
            (!isValidCode || errorCode === 'INVALID_OTP' ? addClass = 'is-error' : addClass = 'is-success');
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "richtext richtext-medium" },
                React.createElement("p", null,
                    t("SetPassword.Otp.Text"),
                    React.createElement("b", null, loginId))),
            React.createElement("div", { className: "s20-spacer s20-spacer--x12" }),
            React.createElement("div", { className: "richtext richtext-medium" },
                React.createElement("p", null,
                    t("SetPassword.Number.Incorrect"),
                    React.createElement("a", { href: '#', onClick: function () { return _this.onClick(); } },
                        React.createElement("b", null, t("SetPassword.Back"))))),
            React.createElement("div", { className: "s20-spacer s20-spacer--x40 is-hidden-mobile" }),
            React.createElement("div", { className: "s20-spacer s20-spacer--x24 is-hidden-desktop" }),
            React.createElement("div", { className: "s20-form-item has-no-bottom-margin " + addClass },
                React.createElement("div", { className: "s20-form-input s20-form-input--text s20-form-input--md" },
                    React.createElement("label", { className: "s20-form-label", htmlFor: "input_u1" }, t("SetPassword.Otp.Label")),
                    React.createElement("input", { className: "s20-form-input__field", id: "input_u1", type: "text", name: "smsCode", value: tvAuthService.formatOtp(smsCode), onChange: function (e) { return _this.handleChange(e.target.name, e.target.value); }, onBlur: function (e) { return _this.handleBlur(e.target.value, e.target.name); }, maxLength: 7, autoComplete: 'off' })),
                (errorCode === 'INVALID_OTP') ? React.createElement("div", { className: 's20-form-note' }, t("SetPassword.Otp.Error")) : null),
            React.createElement("div", { className: "s20-spacer s20-spacer--x20 is-hidden-mobile" }),
            React.createElement("div", { className: "s20-spacer s20-spacer--x12 is-hidden-desktop" })));
    };
    SetPassword.prototype.renderSetPassword = function () {
        var isLoading = this.state.isLoading;
        var t = this.props.t;
        return (React.createElement("div", { className: 'l-center-s' },
            isLoading ? React.createElement(Loader, { type: LoaderType.LIGHT }) : null,
            this.renderTitle(),
            React.createElement("div", { className: 's20-spacer s20-spacer--x12 is-hidden-mobile' }),
            React.createElement("div", { className: 's20-spacer s20-spacer--x8 is-hidden-desktop' }),
            this.enterOtp(),
            React.createElement("h3", { className: "s20-teaser-title s20-teaser-title--regular" }, t("SetPassword.Title.Info")),
            React.createElement("div", { className: 's20-spacer s20-spacer--x12 is-hidden-mobile' }),
            React.createElement("div", { className: 's20-spacer s20-spacer--x8 is-hidden-desktop' }),
            React.createElement("div", { className: "richtext richtext-medium" },
                React.createElement("p", null, t("SetPassword.Text"))),
            React.createElement("div", { className: "s20-spacer s20-spacer--x12" }),
            React.createElement("div", { className: "richtext richtext-medium" },
                React.createElement("p", null, t("SetPassword.Logout.Text"))),
            React.createElement("div", { className: 's20-spacer s20-spacer--x40 is-hidden-mobile' }),
            React.createElement("div", { className: "s20-spacer s20-spacer--x24 is-hidden-desktop" }),
            this.renderPasswordField(),
            React.createElement("div", { className: 's20-spacer s20-spacer--x12' }),
            this.renderConfirmPasswordField(),
            React.createElement("div", { className: 's20-spacer s20-spacer--x20 is-hidden-mobile' }),
            React.createElement("div", { className: 's20-spacer s20-spacer--x12 is-hidden-desktop' }),
            this.renderFormButtons()));
    };
    SetPassword.prototype.renderSupportLink = function () {
        var t = this.props.t;
        return (React.createElement("div", { className: 'tv_setup_link_wrapper' },
            React.createElement("a", { className: 'tv_setup_link_content', href: this.fetchURL() }, t && t("SetPassword.Support.Link")),
            React.createElement("div", { className: 'app-download-right-icon' })));
    };
    SetPassword.prototype.render = function () {
        var _a = this.state, isSuccess = _a.isSuccess, isError = _a.isError;
        if (isSuccess) {
            return (React.createElement(React.Fragment, null,
                React.createElement("div", { className: 'l-center-m' },
                    React.createElement("div", { className: "s20-alert-teaser" }, this.handleSuccess())),
                React.createElement("div", { className: "s20-spacer s20-spacer--x12" }),
                this.renderSupportLink()));
        }
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: 'l-center-m' },
                React.createElement("div", { className: 'content_box' },
                    isError ? this.handleError() : null,
                    this.renderSetPassword())),
            React.createElement("div", { className: 's20-spacer s20-spacer--x60' })));
    };
    return SetPassword;
}(React.Component));
export default withTranslation()(SetPassword);
